import React, { useEffect, useState } from "react";
import { flattenData, timeToSeconds } from "../../../../Utilitie";
import axios from "axios";
import Loading from "../../../../Extra/Loading";
import MachineEngTable from "./MachineEngTable";
import NoDataFound from "../../../../Extra/NoDataFound";
import MachineEngMonthWise from "./MachineEngMonthWise";
const MachineEngCustomTable = ({ data }) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [tableData, setTableData] = useState(null);
  const [machineData, setMachineData] = useState(null);
  const [aDWise, setADWise] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefixBlock}getmachinetype`);
      if (response.data.status === "ok") {
        setMachineData(response.data.machineTypes);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineData();
  }, []);
  // //////////////////////////////////////////////////////////////
  const convertToAssetSummaryFromBlockType = (data, machineData) => {
    const blockTypeToAsset = {};
    const typeToAssetFallback = {};

    // Step 1: Build maps
    for (const dept of machineData) {
      const department = dept.DEPARTMENT;
      for (const type of dept.children || []) {
        for (const assetGroup of type.children || []) {
          const asset = assetGroup.ASSET;
          for (const item of assetGroup.data || []) {
            const blockType = item.ASSET_DISCRIPTION;
            const key = `${department}__${blockType}`;
            blockTypeToAsset[key] = {
              ASSET: asset,
              DEPARTMENT: department,
              TYPE: type.TYPE,
              AssetReadyTime: Number(item.AssetReadyTime),
              Work_Done_Per_Hour: Number(item.Work_Done_Per_Hour),
            };
          }

          // Fallback for TYPE (if no blockType match is found later)
          const typeKey = `${department}__${type.TYPE}`;
          if (!typeToAssetFallback[typeKey]) {
            typeToAssetFallback[typeKey] = {
              ASSET: "-",
              DEPARTMENT: department,
              TYPE: type.TYPE,
              AssetReadyTime: 0,
              Work_Done_Per_Hour: 0,
            };
          }
        }
      }
    }
    const resultMap = {};

    // Step 2: Aggregate
    for (const row of data) {
      const department = row.Department || row.DEPARTMENT || "UNKNOWN";
      const blockType = row.Block_Type;
      const type = row.Type || row.TYPE || "UNKNOWN";

      const key = `${department}__${blockType}`;
      let mapEntry = blockTypeToAsset[key];

      // Fallback to TYPE if no blockType match
      if (!mapEntry) {
        const typeKey = `${department}__${type}`;
        mapEntry = typeToAssetFallback[typeKey];
      }

      // Skip if even TYPE doesn't match
      if (!mapEntry) continue;

      const resultKey = `${mapEntry.DEPARTMENT}__${mapEntry.ASSET}`;
      if (!resultMap[resultKey]) {
        resultMap[resultKey] = {
          DEPARTMENT: mapEntry.DEPARTMENT,
          ASSET: mapEntry.ASSET,
          TYPE: mapEntry.TYPE,
          Actual_Progress: 0,
          Hours_of_Block_Demanded: 0,
          Hours_of_Block_Granted: 0,
          No_Of_Blocks_Demanded: 0,
          No_Of_Blocks_Granted: 0,
          Stipulated_Progress: 0,
          Short_Fall_In_Progress: 0,
          Availed: 0,
          Not_Availed: 0,
          Availed_Hrs: 0,
          Not_Availed_Hrs: 0,
          Machine_ready_time: 0,
        };
      }

      const target = resultMap[resultKey];
      const enggDemandSec = timeToSeconds(row.Engg_Demand);
      const grantedSec = timeToSeconds(row.Availed);
      const noOfGranted = Number(row.No_Of_Demand_Agreed_GIVEN) || 0;
      const assetReadySec = mapEntry.AssetReadyTime || 0;
      const workDonePerHour = mapEntry.Work_Done_Per_Hour || 0;
      const tempNotAvailedHrs =
        row.Granted_Not === "GRANTED" && row.Availed_Not === "NOT AVAILED"
          ? timeToSeconds(row.Granted_Duration)
          : 0;

      target.Actual_Progress += Number(row.Actual_Output_in_Meter) || 0;
      target.Hours_of_Block_Demanded += enggDemandSec;
      target.Hours_of_Block_Granted += grantedSec;
      target.No_Of_Blocks_Demanded += Number(row.No_Of_Demand_By_Engg) || 0;
      target.No_Of_Blocks_Granted += noOfGranted;
      target.Availed += row.Availed_Not === "AVAILED" ? 1 : 0;
      target.Not_Availed =
        target.No_Of_Blocks_Granted - target.Availed > 0
          ? target.No_Of_Blocks_Granted - target.Availed
          : 0;
      target.Not_Availed_Hrs += tempNotAvailedHrs;
      target.Machine_ready_time = assetReadySec;
      target.Stipulated_Progress +=
        ((grantedSec - noOfGranted * assetReadySec) / 3600) * workDonePerHour;
    }

    // Step 3: Format
    return Object.values(resultMap).map((entry) => ({
      ...entry,
      Hours_of_Block_Demanded: entry.Hours_of_Block_Demanded.toString(),
      Hours_of_Block_Granted: entry.Hours_of_Block_Granted.toString(),
      No_Of_Blocks_Demanded: entry.No_Of_Blocks_Demanded.toString(),
      No_Of_Blocks_Granted: entry.No_Of_Blocks_Granted.toString(),
      Stipulated_Progress: entry.Stipulated_Progress.toFixed(2),
      Short_Fall_In_Progress: (
        entry.Actual_Progress - entry.Stipulated_Progress
      ).toFixed(2),
    }));
  };

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////
  const convertToAssetDescriptionSummary = (data, machineData) => {
    const blockTypeToAssetDesc = {};
    const typeToAssetDescFallback = {};

    // Step 1: Build maps
    for (const dept of machineData) {
      const department = dept.DEPARTMENT;

      for (const type of dept.children || []) {
        for (const assetGroup of type.children || []) {
          const asset = assetGroup.ASSET;

          for (const item of assetGroup.data || []) {
            const assetDescription = item.ASSET_DISCRIPTION;

            const key = `${department}__${assetDescription}`;
            blockTypeToAssetDesc[key] = {
              ASSET: asset, // added
              ASSET_DISCRIPTION: assetDescription,
              DEPARTMENT: department,
              TYPE: type.TYPE,
              AssetReadyTime: Number(item.AssetReadyTime) || 0,
              Work_Done_Per_Hour: Number(item.Work_Done_Per_Hour) || 0,
            };
          }

          // TYPE fallback
          const typeKey = `${department}__${type.TYPE}`;
          if (!typeToAssetDescFallback[typeKey]) {
            typeToAssetDescFallback[typeKey] = {
              ASSET: "-", //  fallback asset
              ASSET_DISCRIPTION: "-",
              DEPARTMENT: department,
              TYPE: type.TYPE,
              AssetReadyTime: 0,
              Work_Done_Per_Hour: 0,
            };
          }
        }
      }
    }

    const resultMap = {};

    // Step 2: Aggregate
    for (const row of data) {
      const department = row.Department || row.DEPARTMENT || "UNKNOWN";
      const blockType = row.Block_Type;
      const type = row.Type || row.TYPE || "UNKNOWN";

      const key = `${department}__${blockType}`;
      let mapEntry = blockTypeToAssetDesc[key];

      // Fallback to TYPE
      if (!mapEntry) {
        const typeKey = `${department}__${type}`;
        mapEntry = typeToAssetDescFallback[typeKey];
      }

      if (!mapEntry) continue;

      //  Group by ASSET_DISCRIPTION
      const resultKey = `${mapEntry.DEPARTMENT}__${mapEntry.ASSET_DISCRIPTION}`;

      if (!resultMap[resultKey]) {
        resultMap[resultKey] = {
          DEPARTMENT: mapEntry.DEPARTMENT,
          ASSET: mapEntry.ASSET, //  mentioned
          ASSET_DISCRIPTION: mapEntry.ASSET_DISCRIPTION,
          TYPE: mapEntry.TYPE,
          Actual_Progress: 0,
          Hours_of_Block_Demanded: 0,
          Hours_of_Block_Granted: 0,
          No_Of_Blocks_Demanded: 0,
          No_Of_Blocks_Granted: 0,
          Stipulated_Progress: 0,
          Short_Fall_In_Progress: 0,
          Availed: 0,
          Not_Availed: 0,
          Availed_Hrs: 0,
          Not_Availed_Hrs: 0,
          Machine_ready_time: 0,
        };
      }

      const target = resultMap[resultKey];
      const enggDemandSec = timeToSeconds(row.Engg_Demand);
      const grantedSec = timeToSeconds(row.Availed);
      const noOfGranted = Number(row.No_Of_Demand_Agreed_GIVEN) || 0;
      const assetReadySec = mapEntry.AssetReadyTime || 0;
      const workDonePerHour = mapEntry.Work_Done_Per_Hour || 0;
      const tempNotAvailedHrs =
        row.Granted_Not === "GRANTED" && row.Availed_Not === "NOT AVAILED"
          ? timeToSeconds(row.Granted_Duration)
          : 0;

      target.Actual_Progress += Number(row.Actual_Output_in_Meter) || 0;
      target.Hours_of_Block_Demanded += enggDemandSec;
      target.Hours_of_Block_Granted += grantedSec;
      target.No_Of_Blocks_Demanded += Number(row.No_Of_Demand_By_Engg) || 0;
      target.No_Of_Blocks_Granted += noOfGranted;
      target.Availed += row.Availed_Not === "AVAILED" ? 1 : 0;
      target.Not_Availed =
        target.No_Of_Blocks_Granted - target.Availed > 0
          ? target.No_Of_Blocks_Granted - target.Availed
          : 0;
      target.Not_Availed_Hrs += tempNotAvailedHrs;
      target.Machine_ready_time = assetReadySec;
      target.Stipulated_Progress +=
        ((grantedSec - noOfGranted * assetReadySec) / 3600) * workDonePerHour;
    }

    // Step 3: Format
    return Object.values(resultMap).map((entry) => ({
      ...entry,
      Hours_of_Block_Demanded: entry.Hours_of_Block_Demanded.toString(),
      Hours_of_Block_Granted: entry.Hours_of_Block_Granted.toString(),
      No_Of_Blocks_Demanded: entry.No_Of_Blocks_Demanded.toString(),
      No_Of_Blocks_Granted: entry.No_Of_Blocks_Granted.toString(),
      Stipulated_Progress: entry.Stipulated_Progress.toFixed(2),
      Short_Fall_In_Progress: (
        entry.Actual_Progress - entry.Stipulated_Progress
      ).toFixed(2),
    }));
  };

  useEffect(() => {
    if (machineData && data) {
      const convertedData = convertToAssetSummaryFromBlockType(
        data,
        machineData,
      );
      const convertedDataADWise = convertToAssetDescriptionSummary(
        data,
        machineData,
      );
      setADWise(convertedDataADWise);
      convertedData.sort((a, b) => {
        if (a.DEPARTMENT < b.DEPARTMENT) return -1;
        if (a.DEPARTMENT > b.DEPARTMENT) return 1;
        if (a.TYPE < b.TYPE) return -1;
        if (a.TYPE > b.TYPE) return 1;
        if (a.ASSET < b.ASSET) return -1;
        if (a.ASSET > b.ASSET) return 1;
        return 0;
      });
      setTableData(convertedData);
    }
  }, [data, machineData]);
  return (
    <div>
      <div className="papaDiv position-relative">
        {loading && <Loading />}
        <MachineEngTable
          data={{ data: tableData, aDWise: aDWise }}
          from={"custom"}
        />
        {!tableData && <NoDataFound />}
      </div>
      <div className="papaDiv position-relative">
        {loading && <Loading />}
        <MachineEngMonthWise data={data} from={"custom"} />
        {!tableData && <NoDataFound />}
      </div>
    </div>
  );
};
export default MachineEngCustomTable;
